import { Component, OnInit, HostBinding } from '@angular/core';
import { environment } from 'environment';
import { UserService } from 'user';
import { User } from 'models';
import { SubscriptionSet, AppConfig } from 'common';

@Component({
  selector: 'tyt-plus-ad-block',
  templateUrl: './plus-ad-block.component.html',
  styleUrls: ['./plus-ad-block.component.scss']
})
export class PlusAdBlockComponent implements OnInit {

  constructor(
    private userService : UserService,
    private appConfig : AppConfig
  ) { }

  private subscriptions : SubscriptionSet = new SubscriptionSet();

  async ngOnInit() {
    this.subscriptions.subscribe(
      this.userService.userChanged,
      user => this.user = user
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribeAll();
  }

  user : User;

  @HostBinding('class.visible')
  get visible() {
    if (!this.user)
      return true;
    if (this.user && this.user.membership && this.user.membership.active)
      return false;
    return true;
  }

  get joinUrl() {
    // CAUTION: THIS SHOULD BE CHANGED GLOBALLY (at appConfig) NOT HERE
    return environment.urls.purchase;
  }

}
